import React, { useEffect, useOptimistic, useState } from 'react';
import { GetSpecificRfq } from '../../../../../services/ProductService/AllProductList/AllProductServices';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressCard, faBarcode, faBuilding, faCalendar, faCartShopping, faCreditCard, faEnvelope, faGlobe, faLayerGroup, faMoneyBill, faNewspaper, faPenToSquare, faTag, faTruckFast, faUsers } from '@fortawesome/free-solid-svg-icons';

const SingleRfqView = ({ onClose, onId, onUpdate }) => {

  const [selectedRfqaData, setSelectedRfqData] = useState([])

  const fetchRfq = async (id) => {
    const response = await GetSpecificRfq('GET', id, {})
    setSelectedRfqData(response.data)
  }

  const handleEdit = () =>{
      onUpdate(onId)
  }

  useEffect(() => {
    if (onId) {
      fetchRfq(onId);
    }
  }, []);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-2/3 h-[80vh] relative">
        <button
          onClick={handleEdit}
          className="absolute top-4 right-4 text-gray-300 mx-10 px-7 py-1 text-xl rounded-lg font-bold bg-black hover:bg-gray-700 border-none cursor-pointer"
        >
          <FontAwesomeIcon icon={faPenToSquare} />
        </button>

        <h1 className="text-gray-600 text-2xl font-semibold mt-2 mb-5 pb-3 border-b border-gray-200 px-6 pt-4">
          High Demand / Hot Enquiries
        </h1>
        <div className='overflow-auto h-[450px]'>
          <div className="grid grid-cols-3 gap-10 py-3 px-7 items-center">
            <div className='flex gap-3 items-center'>
              <FontAwesomeIcon className='text-gray-300 text-2xl' icon={faLayerGroup} />
              <p className='text-gray-500'>
                <strong className="text-gray-600">Product Name : </strong>
                {selectedRfqaData.product_name}
              </p>
            </div>
            <div className='flex gap-3 items-center'>
              <FontAwesomeIcon className='text-gray-300 text-2xl' icon={faGlobe} />
              <p className='text-gray-500'>
                <strong className="text-gray-600">Destination : </strong>
                {selectedRfqaData.country}
              </p>
            </div>
            <div className='flex gap-3 items-center'>
              <FontAwesomeIcon className='text-gray-300 text-2xl' icon={faAddressCard} />
              <p className='text-gray-500'>
                <strong className="text-gray-600">Contact : </strong>
                {selectedRfqaData.mobile_number}
              </p>
            </div>
            <div className='flex gap-3 items-center'>
              <FontAwesomeIcon className='text-gray-300 text-2xl' icon={faEnvelope} />
              <p className='text-gray-500'>
                <strong className="text-gray-600">Email : </strong>
                {selectedRfqaData.email}
              </p>
            </div>
            <div className='flex gap-3 items-center'>
              <FontAwesomeIcon className='text-gray-300 text-2xl' icon={faBuilding} />
              <p className='text-gray-500'>
                <strong className="text-gray-600">Company Name : </strong>
                {selectedRfqaData.company_name}
              </p>
            </div>
            <div className='flex gap-3 items-center'>
              <FontAwesomeIcon className='text-gray-300 text-2xl' icon={faBarcode} />
              <p className='text-gray-500'>
                <strong className="text-gray-600">HSN Code : </strong>
                {selectedRfqaData.hsn_code}
              </p>
            </div>
            <div className='flex gap-3 items-center'>
              <FontAwesomeIcon className='text-gray-300 text-2xl' icon={faMoneyBill} />
              <p className='text-gray-500'>
                <strong className="text-gray-600">Target Price : </strong>
                {selectedRfqaData.target_price}
              </p>
            </div>
            <div className='flex gap-3 items-center'>
              <FontAwesomeIcon className='text-gray-300 text-2xl' icon={faTag} />
              <p className='text-gray-500'>
                <strong className="text-gray-600">Target price Negotiable :</strong>
                {selectedRfqaData.is_negotiable ? 'Negotiable' : 'Non Negotiable'}
              </p>
            </div>
            <div className='flex gap-3 items-center'>
              <FontAwesomeIcon className='text-gray-300 text-2xl' icon={faCreditCard} />
              <p className='text-gray-500'>
                <strong className="text-gray-600">Payment terms :</strong>
                {selectedRfqaData.payment_term}
              </p>
            </div>
            <div className='flex gap-3 items-center'>
              <FontAwesomeIcon className='text-gray-300 text-2xl' icon={faUsers} />
              <p className='text-gray-500'>
                <strong className="text-gray-600">Looking for supplier from : </strong>
                {selectedRfqaData.preferred_source_country}
              </p>
            </div>
            <div className='flex gap-3 items-center'>
              <FontAwesomeIcon className='text-gray-300 text-2xl' icon={faCartShopping} />
              <p className='text-gray-500'>
                <strong className="text-gray-600">Quantity Required :</strong>
                {selectedRfqaData.quantity} &nbsp;  {selectedRfqaData.unit}
              </p>
            </div>
            {/* <div className='flex gap-3 items-center'>
              <FontAwesomeIcon className='text-gray-300 text-2xl' icon={faCalendar} />
              <p className='text-gray-500'>
                <strong className="text-gray-600">Date :</strong> Sep 20, 2024</p>
            </div> */}
            <div className='flex gap-3 items-center'>
              <FontAwesomeIcon className='text-gray-300 text-2xl' icon={faTruckFast} />
              <p className='text-gray-500'>
                <strong className="text-gray-600">Shipping terms :</strong>
                {selectedRfqaData.destination_port}
              </p>
            </div>
          </div>

          <div className="px-7 my-6">
            <div className='flex items-center gap-3'>
              <FontAwesomeIcon className='text-gray-500 text-2xl' icon={faNewspaper} />
              <h1 className="text-gray-800 text-xl font-medium mb-3">Product Description :</h1>
            </div>
            <div className="mb-3 indent-10 h-40 p-2 w-full text-gray-600 font-semibold border rounded-lg" >
              {selectedRfqaData.short_description}
            </div>
          </div>
        </div>
        <div className="flex justify-end px-6 mx-5 my-6">
          <button className="bg-blue-500 hover:bg-blue-400 text-white font-bold py-2 px-5 rounded-lg"
            onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SingleRfqView;